function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.9566 7.75C16.9566 7.33578 16.6208 7 16.2066 7L14.9899 7.00001L9.98993 11H6.75C6.33579 11 6 11.3358 6 11.75V20.25C6 20.6642 6.33579 21 6.75 21H9.98993L14.9899 25.0104L16.2105 25.0039C16.6232 25.0018 16.9566 24.6666 16.9566 24.254V7.75Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.7222 12.4697C20.6246 12.3721 20.4663 12.3721 20.3687 12.4697L19.4697 13.3687C19.3721 13.4664 19.3721 13.6246 19.4697 13.7223L21.7475 16L19.4697 18.2778C19.3721 18.3754 19.3721 18.5337 19.4697 18.6314L20.3687 19.5304C20.4663 19.628 20.6246 19.628 20.7222 19.5304L23 17.2526L25.2778 19.5304C25.3754 19.628 25.5337 19.628 25.6313 19.5304L26.5303 18.6314C26.628 18.5337 26.628 18.3754 26.5303 18.2778L24.2526 16L26.5303 13.7223C26.628 13.6246 26.628 13.4664 26.5303 13.3687L25.6313 12.4697C25.5337 12.3721 25.3754 12.3721 25.2778 12.4697L23 14.7475L20.7222 12.4697Z"
});

var SvgSoundoff = function SvgSoundoff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSoundoff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Soundoff.d3f09cc4.svg";
export { ForwardRef as ReactComponent };